<template lang="html">
    <div class="page" id="messages">
        <header class="pageHeader">
            <fade-image src="assets/headers/messages.png" />
        </header>

        <div id="scroller" class="small">
            <div class="pageHeaderIntro">
                <h1>Messages</h1>
                <img class="icon" src="~@/assets/Messages.svg" />
            </div>
            <h2 class="title" v-if="latestMessage" style="margin-bottom: 20px">Latest message:</h2>

            <message-item
                class="latestMessage"
                v-if="latestMessage"
                :showFrom="true"
                :message="latestMessage"
                :isSentMessage="true"
            />

            <router-link :to="{ name: 'proPlayerMessagesNew' }" class="button">
                Create new message
                <img class="icon2" src="@/assets/arrow-right-white-2.svg" />
            </router-link>

            <router-link :to="{ name: 'proPlayerMessagesInbox' }" class="button dark">
                View message inbox
                <img class="icon2" src="@/assets/arrow-right-white-2.svg" />
            </router-link>

            <router-link :to="{ name: 'proPlayerMessagesSent' }" class="button dark">
                View sent messages
                <img class="icon2" src="@/assets/arrow-right-white-2.svg" />
            </router-link>

            <router-link :to="{ name: 'proPlayerMessagesGroups' }" class="button dark">
                Edit groups
                <img class="icon2" src="@/assets/arrow-right-white-2.svg" />
            </router-link>
        </div>
    </div>
</template>

<script>
import MessageItem from "@/components/Pro/Messages/Message-item";
import FadeImage from "@/components/App/fade-image";
export default {
    name: "messages",
    components: { FadeImage, MessageItem },
    created() {
        this.$store.dispatch("getMessages");
    },
    computed: {
        latestMessage() {
            if (!this.$store.state.messages) {
                return false;
            }
            return this.$store.state.messages[0];
        },
    },
};
</script>

<style lang="scss" scoped>
#messages {
    .button {
        margin-bottom: 10px;
    }
    .latestMessage {
        margin-bottom: 20px;
    }
    .icon2 {
        position: absolute;
        right: 20px;
        top: 19px;
    }
}
</style>
